module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_1-0d58efe6a1c6923c00dd8c2a51c6f906.jpg";